var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,6H23a1,1,0,0,0,0-2H7A1,1,0,0,0,7,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,18H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 5,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 12,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 19,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPointIcon);
export default __webpack_public_path__ + "static/media/bulletPointIcon.beeae5d4dbef4c0b18ec1632dac933fa.svg";
export { ForwardRef as ReactComponent };